<template>
  <a class="link-item--wrapper d-flex align-items-center justify-content-between my-3">
    <span class="f-12" @click.prevent="navigateTo(url)">
      {{ name }}
    </span>
    <div>
      <span class="material-icons green-icon mx-3" @click.prevent="navigateTo(url)">
        cloud_download
      </span>
      <span
        v-if="getByFileType(file)"
        class="material-icons green-icon mr-3"
        @click.prevent="openFrame"
      >
        launch
      </span>
    </div>
  </a>
</template>

<script setup>
const props = defineProps({
  url: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "filename",
  },
  file: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["openFileViewer"]);

function getByFileType(file) {
  const ext = String(file?.ext || "").toLowerCase();
  const mime = String(file?.type || "").toLowerCase();
  const fileType = ["doc", "docx", "ppt", "xls", "pptx", "pdf"];
  if (mime.startsWith("image/")) return true;
  if (fileType.includes(ext)) return true;
  return false;
}

function openFrame() {
  emit("openFileViewer", {
    url: props.url,
    type: props?.file?.type || "",
  });
}

function navigateTo(fileUrl) {
  const link = String(fileUrl || "").trim();
  if (!link) return;
  window.open(link, "_blank", "noopener,noreferrer");
}
</script>

<style scoped lang="scss">
.link-item {
  &--wrapper {
    color: #828282;

    &:hover {
      text-decoration: none;
    }

    div {
      span {
        color: #66bb6a;
      }
    }

    span {
      color: #828282;
      word-break: break-all;
    }
  }
}
</style>
